// historialLinks.js (adaptado sin paginación temporal)
import React, { useState, useEffect, useRef } from 'react';
import { Link, useParams } from 'react-router-dom';
import { useQuery } from '@apollo/react-hooks';
import gql from 'graphql-tag';
import HistorialIcon from './icons/historial';
import DeleteButton from './deleteAndLikes/deleteButomTrainedHistorial'; // opcional (seguirá comentado abajo)
import Verdetalle from './detalleLink';
import './historial.css';
import useClickOutside from './modulos-propios/useClickOutside';

const FETCH_POSTS_QUERY_USER_LINK = gql`
  query getPostsLinkByUsername($username: String!) {
    getPostsLinkByUsername(username: $username) {
      id
      linkOwner
      destinatario
      estado
      informacion
      createdAt
    }
  }
`;

function FilteredPosts({ refetch, user }) {
  const username = (user || '').replace(/[^a-zA-Z0-9]/g, '');
  const { postId } = useParams();

  const [dropdownStates, setDropdownStates] = useState({});
  const dropdownRefs = useRef({});
  const [isModalDetalleOpen, setIsModalDetalleOpen] = useState(false);

  // hook para cerrar dropdowns al hacer click fuera
  useClickOutside(Object.values(dropdownStates).some(Boolean), () =>
    setDropdownStates({})
  );

  const { loading, error, data, refetch: queryRefetch } = useQuery(
    FETCH_POSTS_QUERY_USER_LINK,
    { variables: { username }, skip: !username }
  );

  // Permite refrescar desde el padre
  useEffect(() => {
    if (refetch) {
      queryRefetch();
    }
  }, [refetch, queryRefetch]);

  // Cerrar dropdown si se hace click fuera del nodo individual
  useEffect(() => {
    const handleClickOutside = (event) => {
      Object.keys(dropdownRefs.current).forEach((key) => {
        if (
          dropdownRefs.current[key] &&
          !dropdownRefs.current[key].contains(event.target)
        ) {
          setDropdownStates((prev) => ({ ...prev, [key]: false }));
        }
      });
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleDropdownToggle = (id) => {
    setDropdownStates((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  if (loading) {
    return (
      <div className="spinner-container">
        <div className="spinner">
          <img src="/images/logo512.png" alt="loading" />
        </div>
      </div>
    );
  }

  if (error) return <p>Error: {error.message}</p>;

  // Lista continua SIN paginación: ordenar por fecha desc
  const posts = (data?.getPostsLinkByUsername || [])
    .slice()
    .sort(
      (a, b) =>
        new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
    );

  return (
    <div className="historial-wrapper">
      <div className="posts-container fade-bottom">
        {posts.map((post, index) => {
          const isActive = String(post.id) === String(postId);
          const text =
            (post.destinatario || '').length > 19
              ? post.destinatario.substring(0, 19).toLowerCase() + '..'
              : (post.destinatario || '').toLowerCase();

          // Opacidad suave por índice (igual al estilo usado en historialRecto)
          const opacity = Math.max(0.35, 1 - index * 0.015);

          return (
            <div
              key={post.id}
              className="post-item"
              style={{ opacity }}
              ref={(el) => (dropdownRefs.current[post.id] = el)}
            >
              <Link
                to={`/estadoLink/${post.id}`}
                className={['post-link', isActive ? 'active' : ''].join(' ')}
                title={post.destinatario}
              >
                <HistorialIcon size={13} />
                {' ' + text}
                <span className="created-at">
                  {new Date(post.createdAt).toLocaleString()}
                </span>
              </Link>

              {isActive && (
                <button
                  className="dropdownH-toggle"
                  onClick={() => handleDropdownToggle(post.id)}
                >
                  <span className="vertical-dots"></span>
                </button>
              )}

              {dropdownStates[post.id] && (
                <div id="dropdownH" className="dropdownH">
                  <div className="dropdownH-menu">
                    {/* Si luego quieres habilitar el borrado:
                    <DeleteButton
                      postId={post.id}
                      index={index}
                      username={post.linkOwner}
                      refetch={refetch}
                    /> */}
                    <button>
                      <a onClick={() => setIsModalDetalleOpen(true)}>
                        Ver detalle
                      </a>
                      <Verdetalle
                        isOpen={isModalDetalleOpen}
                        onClose={() => setIsModalDetalleOpen(false)}
                        titulo={post.destinatario}
                        resumen={post.informacion}
                      />
                    </button>
                  </div>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default FilteredPosts;




